import React from "react"; 
import SlidersSectionAmazon from "./SlidersSectionAmazon";
 import BestSellsAmazon from "./BestSellsAmazon";
 import TopVendorsAmazon from "./TopVendorsAmazon";
import TopSellings from "./TopSellings"; 
import SearchLoader from "./SearchLoader";
import TopVendorsSearchAmazon from "./TopVendorsSearchAmazon";
import TopInternationalSales from "./TopInternationalSales";
import { hasRole } from "../auth";
   
const LandingComponent = () => {
  const isCustomer = hasRole('ROLE_CUSTOMER'); // Check if the user has the 'customer' role
 
    return (
      <>
      
      {/* SlidersSectionAmazon */}
      <SlidersSectionAmazon />
       {isCustomer && (
      <SearchLoader />
    )}
      <TopInternationalSales />
       {/* PopularProductsOne */}
       <TopSellings />
        {/* TrendingThree */}
        {isCustomer && (
      <TopVendorsSearchAmazon />
    )}
        {/* BestSellsOne */} 
      <BestSellsAmazon />
      
      {/* TrendingThree */}
      {isCustomer && (
      <TopVendorsAmazon />
    )}
   
      </>
   
  );
};

export default LandingComponent;
